export default "__VITE_ASSET__DGG3iQ8G__"